import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Sense() {
    return (
        <OnboardingBody title='Making sense of the data'>
            <p>
                So, how can you use this information to make better sales and marketing decisions?
            </p>
            <p>
                The answer is simple: <strong>reporting</strong>.
            </p>
            <p>
                By analyzing which channels are generating the most leads (and which ones are
                underperforming), you can make informed decisions about where to invest your team’s
                time and energy.
            </p>
        </OnboardingBody>
    );
}
